module.exports = __webpack_public_path__ + "img/blueStamp.787f6ae9.png";